import { render } from "./ModalReportErrorCards.vue?vue&type=template&id=60def9ac&scoped=true"
import script from "./ModalReportErrorCards.vue?vue&type=script&lang=js"
export * from "./ModalReportErrorCards.vue?vue&type=script&lang=js"

import "./ModalReportErrorCards.vue?vue&type=style&index=0&id=60def9ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60def9ac"]])

export default __exports__